// INITIAL_DRAFT = "INITIAL_DRAFT"
// WORKING_DRAFT = "WORKING_DRAFT" 오더 작성 중
// ORDERED_TO_AGENCY = "ORDERED_TO_AGENCY" 오더 완료
// #    AGENCY_CONFIRMED = "AGENCY_CONFIRMED"
// ORDERED_TO_BOUTIQUE = "ORDERED_TO_BOUTIQUE" 오더 협의 중
// RESUBMIT_REQUIRED = "RESUBMIT_REQUIRED" 바어이 수정 필요
// RESUBMIT_COMPLETED = "RESUBMIT_COMPLETED" 재오더 완료
// BOUTIQUE_CONFIRMED = "BOUTIQUE_CONFIRMED" 바이어 승인 필요
// BUYER_CONFIRMED = "BUYER_CONFIRMED" 오더 확정
// #    COMPLETED = "COMPLETED" 완료
// CANCELED = "CANCELED" 취소

import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";
import { RemittanceRequiredCategory } from "@/features/my-order/features/order-history/types";

export const newOrderStatusMap: Partial<Record<OrderSheetStatus, string>> = {
  WORKING_DRAFT: "WORKING_DRAFT", // 오더 작성 중
  ORDERED_TO_AGENCY: "ORDER_SUBMITTED", // 오더 완료
  ORDERED_TO_BOUTIQUE: "ORDER_CONSULTING", // 오더 협의 중
  RESUBMIT_REQUIRED: "BUYER_MODIFICATION_REQUIRED", // 바이어 수정 필요
  RESUBMIT_COMPLETED: "RESUBMIT_COMPLETED", // 재오더 완료
  BOUTIQUE_CONFIRMED: "BUYER_CONFIRM_REQUIRED", // 바이어 승인 필요
  BUYER_CONFIRMED: "ORDER_CONFIRMED", // 오더 확정
  COMPLETED: "COMPLETED", // 완료
  CANCELED: "ORDER_CANCELED", // 오더 취소

  INITIAL_DRAFT: "INITIAL_DRAFT",
  AGENCY_CONFIRMED: "AGENCY_CONFIRMED",
  MODIFICATION_REQUIRED: "MODIFICATION_REQUIRED",
  MODIFICATION_COMPLETED: "MODIFICATION_COMPLETED",
  TRANSPORTATION_ING: "TRANSPORTATION_ING",
  TRANSPORTATION_COMPLETED: "TRANSPORTATION_COMPLETED",
} as const;

export const orderStatusOptionList = [
  { name: "order_submitted", value: "ORDER_SUBMITTED" },
  { name: "order_consulting", value: "ORDER_CONSULTING" },
  { name: "buyer_modification_required", value: "BUYER_MODIFICATION_REQUIRED" },
  { name: "resubmit_completed", value: "RESUBMIT_COMPLETED" },
  { name: "buyer_confirm_required", value: "BUYER_CONFIRM_REQUIRED" },
  { name: "order_confirmed", value: "ORDER_CONFIRMED" },
  { name: "transportation_ing", value: "TRANSPORTATION_ING" },
  { name: "transportation_completed", value: "TRANSPORTATION_COMPLETED" },
  { name: "completed", value: "COMPLETED" },
  { name: "order_canceled", value: "ORDER_CANCELED" },
  // { name: "initial_draft", value: "INITIAL_DRAFT" },
  { name: "working_draft", value: "WORKING_DRAFT" },
  { name: "agency_confirmed", value: "AGENCY_CONFIRMED" },
  { name: "modification_required", value: "MODIFICATION_REQUIRED" },
  { name: "modification_completed", value: "MODIFICATION_COMPLETED" },
];

// newOrderStatusMap의 value(새 상태) -> key(기존 OrderSheetStatus) 역매핑
export const oldOrderStatusMap: Partial<Record<string, OrderSheetStatus>> = {
  WORKING_DRAFT: "WORKING_DRAFT",
  ORDER_SUBMITTED: "ORDERED_TO_AGENCY",
  ORDER_CONSULTING: "ORDERED_TO_BOUTIQUE",
  BUYER_MODIFICATION_REQUIRED: "RESUBMIT_REQUIRED",
  RESUBMIT_COMPLETED: "RESUBMIT_COMPLETED",
  BUYER_CONFIRM_REQUIRED: "BOUTIQUE_CONFIRMED",
  ORDER_CONFIRMED: "BUYER_CONFIRMED",
  COMPLETED: "COMPLETED",
  ORDER_CANCELED: "CANCELED",

  INITIAL_DRAFT: "INITIAL_DRAFT",
  AGENCY_CONFIRMED: "AGENCY_CONFIRMED",
  MODIFICATION_REQUIRED: "MODIFICATION_REQUIRED",
  MODIFICATION_COMPLETED: "MODIFICATION_COMPLETED",
  TRANSPORTATION_ING: "TRANSPORTATION_ING",
  TRANSPORTATION_COMPLETED: "TRANSPORTATION_COMPLETED",
} as const;

export const remittanceRequiredStatusOptionList: {
  name: string;
  value: RemittanceRequiredCategory;
}[] = [
  { name: "product", value: "PRODUCT" },
  // { name: "adjustment", value: "ADJUSTMENT" },
  { name: "transportation", value: "TRANSPORTATION" },
  { name: "uno_fee", value: "UNO_FEE" },
];
